<template>
  <div>
    <page-header title="ویرایش پروفایل"></page-header>

    <v-form @submit.prevent="updateUserInfo" v-model="form">
      <v-card class="settings-card">
        <v-card-title><v-icon left>mdi-account</v-icon>اطلاعات حساب</v-card-title>
        <v-card-text>
          <v-row dense>
            <v-col cols="12" md="6">
              <v-text-field color="#00ADB5" v-model="user.name" label="نام کاربری"
                            prepend-inner-icon="mdi-account" required outlined></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field color="#00ADB5" v-model="user.email" label="ایمیل" dir="ltr"
                            prepend-inner-icon="mdi-email" required outlined></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-card class="settings-card">
        <v-card-title><v-icon left>mdi-lock</v-icon>رمز عبور</v-card-title>
        <v-card-subtitle>برای ذخیره هر تغییری، رمز عبور فعلی خود را وارد کنید.</v-card-subtitle>
        <v-card-text>
          <v-row dense>
            <v-col cols="12" md="4">
              <v-text-field
                  v-model="old_password"
                  :rules="oldPasswordRules"
                  label="رمز عبور فعلی"
                  type="password"
                  placeholder="رمز عبور خود را وارد کنید."
                  required
                  outlined
                  color="#00ADB5"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field color="#00ADB5" v-model="new_password" label="رمز عبور جدید" type="password" outlined></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field color="#00ADB5" v-model="new_password_confirmation" label="تایید رمز عبور جدید" type="password" outlined></v-text-field>
            </v-col>
          </v-row>
          <div class="form-actions">
            <v-btn class="btn-primary" type="submit" large depressed>
              <v-icon left>mdi-content-save</v-icon>
              ذخیره تغییرات
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import PageHeader from "@/components/General/PageHeader.vue";

export default {
  name: "ProfileView",
  components: {PageHeader},
  data: () => ({
    form: false,
    old_password: "",
    new_password: "",
    new_password_confirmation: "",
    user: {
      id: "",
      name: "",
      token: "",
      email: "",
    },
    oldPasswordRules: [(v) => !!v || "پر کردن این فیلد ضروریست."],
  }),

  mounted() {
    this.getUser();
  },

  methods: {
    getUser() {
      this.$store.dispatch("getProfile").then((res) => {
        this.user = res.data.data.admin;
      });
    },

    updateUserInfo() {
      let admin = {
        old_password: this.old_password,
        name: this.user.name,
        email: this.user.email,
        new_password: this.new_password,
        new_password_confirmation: this.new_password_confirmation,
      };
      this.$store.dispatch("updateProfile", admin).then();
    },
  },
};
</script>

<style scoped>
</style>
